export const ZarazEvents = {
  LOGIN_CLICK: "login_click",
  LOGIN_SUCCESS: "login_success",
  SIGNUP_SUCCESS: "signup_success",
  CHECKOUT_CLICK: "checkout_click",
  BILLING_PORTAL_CLICK: "billing_portal_click",
  CHECKOUT_CUSTOM_CONTACT_US_CLICK: "checkout_custom_contact_us_click",
  CHECKOUT_CANCELLED: "checkout_cancelled",
  CHECKOUT_SUCCESS: "checkout_success",
} as const;

export type ZarazEvent = typeof ZarazEvents[keyof typeof ZarazEvents];
